import { Translate, TranslatePlural } from '@change-corgi/core/react/i18n';
import { Button } from '@change-corgi/design-system-legacy/components/actions';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { iconNotificationsNone } from '@change-corgi/design-system-legacy/icons';
import { Flex } from '@change-corgi/design-system-legacy/layout';
import { Heading, Text } from '@change-corgi/design-system-legacy/typography';

import { useDecisionMakerNotification } from './hooks/useDecisionMakerNotification';

export function DecisionMakerRecommendation() {
	const { data, actions } = useDecisionMakerNotification();

	return (
		<Flex data-qa="dm-recommendation-section-message" p={24} sx={{ height: '100%', gap: 16 }}>
			<Icon icon={iconNotificationsNone} size={24} color="primary-white" />
			<Flex sx={{ flexDirection: 'column', alignItems: 'flex-start' }}>
				<Heading as="h2" size="h4">
					<TranslatePlural
						value="corgi.petition.starter_dashboard.notifications.dm_recommendation.title"
						replacements={{ numDecisionMakers: data.numDecisionMakers }}
						count={data.numDecisionMakers}
					/>
				</Heading>
				<Text mt={8}>
					<Translate value="corgi.petition.starter_dashboard.notifications.dm_recommendation.body" />
				</Text>
				<Button
					data-testid="dm-recommendation-button"
					variant="secondary"
					size="small"
					onClick={actions.handleOpenModal}
					mt={16}
				>
					<TranslatePlural
						value="corgi.petition.starter_dashboard.notifications.dm_recommendation.primary_action_button"
						count={1}
					/>
				</Button>
			</Flex>
		</Flex>
	);
}
